import React, { createContext, useContext, useState } from 'react';

import { IBaseProps, SetState } from '@rbi-ctg/frontend';
import useEffectOnUnmount from 'hooks/use-effect-on-unmount';
import noop from 'utils/noop';

export interface IMobileHeaderNavContext {
  isBackButtonVisible: boolean;
  setBackButtonVisible: SetState<boolean>;
}

export const MobileHeaderNavContext = createContext<IMobileHeaderNavContext>({
  isBackButtonVisible: false,
  setBackButtonVisible: noop,
});

export const MobileHeaderNavProvider = ({ children }: IBaseProps) => {
  const [isBackButtonVisible, setBackButtonVisible] = useState(false);

  return (
    <MobileHeaderNavContext.Provider value={{ isBackButtonVisible, setBackButtonVisible }}>
      {children}
    </MobileHeaderNavContext.Provider>
  );
};

export const useMobileHeaderNavContext = () => useContext(MobileHeaderNavContext);

export const useBackButtonState = () => {
  const { isBackButtonVisible, setBackButtonVisible } = useMobileHeaderNavContext();
  useEffectOnUnmount(() => {
    setBackButtonVisible(false);
  });
  return { isBackButtonVisible, setBackButtonVisible };
};
